export const PROSPECTS_ACTIONS = {
    FIND: 'FIND_PROSPECTS',
    GET: 'GET_PROSPECTS',
    GET_INDIVIDUAL: 'GET_INDIVIDUAL_PROSPECTS',
    GET_STAGES: 'GET_STAGES_PROSPECTS',
    TRACEABILITY: 'TRACEABILITY_PROSPECTS',
    SUCCESS: 'SUCCESS_PROSPECTS',
    SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE_PROSPECTS',
    GET_VISITS: 'GET_VISITS_PROSPECTS',
    GET_REPORT_VISITS: 'GET_REPORT_VISITS_PROSPECTS',
    ERROR: 'ERROR_PROSPECTS',
    CLEAN: 'CLEAN_PROSPECTS',
    CLEAN_IMPORTS: 'CLEAN_IMPORTS_PROSPECTS',
}